<template>
  <div class="container-fluid">
    <router-link v-if="isAdmin" class="btn btn-circle torre-red" :to="{ name: 'colorsNew' }" title="Dodaj kolor">
      <i class="material-icons" >
      add
      </i>
    </router-link>
    <div v-if="showMsg" :class="'alert ' + msg.type" role="alert">
      {{ msg.text }}
    </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th class="table-33">
            <div class="input-group-sm mb-2">
              <label >Nazwa</label>
              <input class="form-control" @keyup="onTextChanged" v-model="form.search"/>
            </div>
          </th>
          <th v-if="isAdmin" class="table-33 align-top">
            <div class="input-group-sm align-top mb-2">
              <label >Edytuj</label>
            </div>
          </th>
          <th v-if="isAdmin" class="table-33 align-top">
            <div class="input-group-sm align-top mb-2">
              <label >Usuń</label>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in colors" :key="item.id">
          <td>{{ item.name }}</td>
          <td v-if="isAdmin">
            <router-link :to="{ name: 'colorsEdit', params: { id: item.id} }">edytuj</router-link>
          </td>
          <td v-if="isAdmin">
            <button class="btn btn-dark btn-sm" @click="deleteColorConfirm(item.id)">usuń</button>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="showEmptyResult" class="row">
      <div class="col text-center">
        Brak wyników
      </div>
    </div>
    <common-pagination @paginationClicked="onPaginationClicked"/>
  </div>
</template>

<script>
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import flashService from '@/service/flashService'
import MainPresenter from "@/service/MainPresenter"
import un from 'underscore'
import { escapeParam } from "@/service/UrlEncoder"
import alertify from 'alertifyjs';
import validator from 'validator'

const mainPresenter = new MainPresenter();

export default {
  name: 'Colors',
  data: function () {
    return {
      pageable: appConfig.pageableMainParams,
      loading: false,
      colors: [],
      form: {
        search: ""
      },
      msg:{
        show: false,
        text: "",
        type: ""
      }
    }
  },
  computed: {
    showMsg() {
      return this.msg.show
    },
    showEmptyResult() {
      return this.loading === false && this.colors.length === 0
    },
    isAdmin() {
      return userService.isAdmin()
    }
  },
  created: function () {
    this.pageable.page = 0;
    const msg = flashService.get("msg");
    if (msg) {
      this.msg = {
        show: true,
        text: msg.text,
        type: msg.type
      }
    }
    this.reloadContent();
  },
  methods: {
    deleteColorConfirm(id) {
      const that = this
      alertify.confirm('', 'Chcesz usunąć kolor?', function(){
          that.deleteColor(id)
        }, function(){},
      );
    },
    onTextChanged: un.debounce(function (e) {
      this.pageable.page = 0;
      this.reloadContent();
    }, 300),
    deleteColor(id) {
      const req = axios({
        method: 'delete',
        url: mainPresenter.getUrlForCommonData("/colors/" + id, {}, {}),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        const msg = "Usunięto kolor " + this.getColorById(id);
        alertify.set('notifier','position', 'top-center');
        alertify.success(msg).delay(3);
        this.reloadContent();
      }).catch(e=> {
        console.log(e)
      })
    },
    getColorById(id) {
      return un.find(this.colors,function(item) {
        return item.id === id
      }).name;
    },
    getRequestData() {
      return validator.isEmpty(this.form.search) ?
      {
        url: "/colors/",
        data: {}
      }
      :
      {
        url: "/colors/search/findByNameContainsIgnoreCase",
        data: {
          name: escapeParam(this.form.search)
        }
      }
    },
    reloadContent() {
      this.loading = true
      const requestData = this.getRequestData();
      this.pageable.sort = "name,asc"
      const req = axios({
        method: 'get',
        url: mainPresenter.getUrlForCommonData(requestData.url, requestData.data, this.pageable),
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.colors = res.data._embedded.colors;
        this.$emit('dataChanged', {
          data: res.data
        });
        this.loading = false
      }).catch(_ => {
        this.loading = false
        console.log('blad categories')
      })
    },
    onPaginationClicked(payload) {
      var pageToSend = payload.pageToSend;
      this.pageable.page = pageToSend;
      this.reloadContent();
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/colors/Colors.vue